export default __webpack_public_path__ + "static/media/arrows-black.3571e4a1.svg";